// extracted by mini-css-extract-plugin
export default {"leaderIframe":"styles_leaderIframe__1ITxp"};